<template lang="pug">

  what-is-this-link
    .card-number-help

</template>

<script>
export default {
  name: 'what-is-this-number-link'
}
</script>
